import { Editor } from "primereact/editor";
import Quill from "quill";
import { useEffect, useState } from "react";
import { RenderConfig } from "./ValidatedField";
import { ErrorText } from "../errors/ErrorText";

const block = Quill.import("blots/block");
block.tagName = "DIV";
Quill.register(block, true);

const colorOptions = [
	{ value: "#000000", label: "Black" },
	{ value: "#ffffff", label: "White" },
	{ value: "#ff0000", label: "Red" },
	{ value: "#0000ff", label: "Blue" },
	{ value: "#ffff00", label: "Yellow" },
	{ value: "#808080", label: "Gray" },
	{ value: "#4ba540", label: "Green-InfectoPharm" },
	{ value: "#0099cc", label: "Paedia Color" },
];
export const DefaultTextEditorComponent = ({
	fieldName,
	fieldValue,
	updateField,
	noLineBreak,
	onChange,
	showListButtons,
	showLinkButton,
	showColorsPalette,
}: RenderConfig<string>) => {
	const [errorLineBreak, setErrorLineBreak] = useState(false);
	const updateFieldValue = (text: string | undefined) => {
		const updatedValue = text;
		if (noLineBreak && updatedValue) {
			updateField(
				updatedValue
					.replace(/<\/div><div><br><\/div><div>/, " ")
					.replace(/<\/div><div>/, " ")
					.replace(/<br>/, " ") || undefined,
			);
			if (updatedValue.includes("</div><div>")) {
				setErrorLineBreak(true);
			} else {
				setErrorLineBreak(false);
			}
		} else {
			updateField(updatedValue || undefined);
		}
	};

	useEffect(() => {
		if (noLineBreak) {
			if (fieldValue?.includes("</div><div>")) {
				setErrorLineBreak(true);
				fieldValue
					.replace(/<\/div><div><br><\/div><div>/, " ")
					.replace(/<\/div><div>/, " ")
					.replace(/<br>/, " ");
			}
		}
	}, [fieldValue, noLineBreak]);

	const replaceHtmlTags = (text: any) => {
		const regex = /(<([^>]+)>)/gi;
		if (text !== undefined) {
			return text.replace(regex, "");
		}
	};

	const checkIfTheFormIsGettingEdited = (e: any) => {
		if (
			replaceHtmlTags(fieldValue) !== replaceHtmlTags(e.htmlValue) &&
			fieldValue !== undefined
		) {
			if (onChange) {
				onChange();
			}
		}
	};
	return (
		<div>
			{errorLineBreak && (
				<ErrorText errortext={"Bitte keine Zeilenumbrüche einfügen"}></ErrorText>
			)}{" "}
			<Editor
				headerTemplate={
					<div className="p-editor-toolbar">
						<span className="ql-formats">
							<button className="ql-bold" aria-label="Bold" />
							<button className="ql-italic" aria-label="Italic" />
							<button className="ql-underline" aria-label="Underline" />
							{showLinkButton && <button className="ql-link" aria-label="Link" />}
							{showColorsPalette && (
								<select className="ql-color">
									{colorOptions.map((color) => (
										<option key={color.label} value={color.value} />
									))}
								</select>
							)}
							{showListButtons && (
								<button
									className="ql-list"
									value="ordered"
									aria-label="Geordnete Liste"
								/>
							)}
							{showListButtons && (
								<button
									className="ql-list"
									value="bullet"
									aria-label="Ungeordnete Liste"
								/>
							)}
							<button className="ql-clean" aria-label="Style entfernen" />
						</span>
					</div>
				}
				id={fieldName}
				value={fieldValue}
				onTextChange={(e) => {
					const newValue = e.htmlValue || undefined;
					checkIfTheFormIsGettingEdited(e);
					setTimeout(() => updateFieldValue(newValue), 100);
				}}
			/>
		</div>
	);
};
